import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"items":_vm.items,"label":_vm.$t('Policy'),"hint":_vm.policyHint,"color":"primary","persistent-hint":"","outlined":""},model:{value:(_vm.policy),callback:function ($$v) {_vm.policy=$$v},expression:"policy"}})}
var staticRenderFns = []

export { render, staticRenderFns }